export default __webpack_public_path__ + "static/media/Noticebard.d67414b9.png";